exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.svg-icon[data-v-c8a70580] {\n\twidth: 1em;\n\theight: 1em;\n\tvertical-align: -0.15em;\n\tfill: currentColor;\n\toverflow: hidden;\n}\n.svg-external-icon[data-v-c8a70580] {\n\tbackground-color: currentColor;\n\t-webkit-mask-size: cover !important;\n\t        mask-size: cover !important;\n\tdisplay: inline-block;\n}\n", ""]);

// exports
